export default __webpack_public_path__ + "static/media/consorcioLogo.8d6ac821.svg";